import React from 'react';
import toast from '@util/toast';
import './index.scss';
export const UnitLi = (props) => {
    // const hasShowImg = props.imageUrls.length > 0 || props.surfacePlot;
    return (
        <div className="response-unit-li-box">
            <a hidden={!props.imageUrls || props.imageUrls.length <= 0} href={`/question/detail/${props.id}`} className="question-img">
                <img src={props.imageUrls.length > 0 ? props.imageUrls[0]['imageUrl'] : props.surfacePlot} alt="" />
            </a>
            <div className="question-info-box">
                <div className="question-title-tag">
                    <h3><a href={`/question/detail/${props.id}`}>{substrTit(props.title)}</a></h3>
                    <p className="question-tag-box">
                        <span className="answer-tag"><i>答</i>{props.answerSum}</span><span className="collect"><i></i>{props.collectSum}</span>
                    </p>
                    <p className="question-date">{props.releaseTime}</p>
                </div>{
                    // tslint:disable-next-line: jsx-no-lambda
                    <a onClick={() => goResponse(props.status, props.id, props.checkAnswer)} className="response-button">回答</a>}
            </div>
        </div>
    );
};

const goResponse = (status, id, checkAnswer) => {
    // window.location.href = `/question/response/${id}`;
    checkAnswer(id).then((res) => {
        if (res) {
            window.location.href = `/question/response/${id}`;
        } else {
            toast.warning('该问题您已回答过');
        }
    }).catch((err) => {
        toast.error(err.msg);
    });
};

function substrTit(title) {
    if (title.length > 113) {
        return title.substr(0, 113) + '...';
    }
    return title;
}
